import { FacebookAlbumsPicker } from './FacebookAlbumsPicker'
export { FacebookAlbumsPicker }
export default FacebookAlbumsPicker
